export enum MarketplaceLearnMoreEmailFields {
  FIRST_NAME = 'first_name',
  LAST_NAME = 'last_name',
  CRB_ORG_NAME = 'crb_org_name',
  SP_ORG_NAME = 'sp_org_name'
}
